<template>
    <section class="padding-vertical-content">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <ul class="matches">
                        <template v-for="event in eventos">
                            <EventoClub :productos="productos" :key="event.id" :event="event"/>
                        </template>
                    </ul>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import EventoClub from './EventoClub';

    export default {
        props: {
            eventos: {
                required: true,
                type: Array
            },
            productos: {
                required: false,
                default:false,
                type: Boolean
            }
        },
        components: {
            EventoClub
        }
    }
</script>